export default __webpack_public_path__ + "static/tag-do-5-dark-2cbe01ea93df956626397146e03977f4.png";